import { CheckCircle2, Clock, Plus, ListChecks, X } from "lucide-react";

export function StepDone({ result, process, model, onAgain, onOther, onClose }) {
  const fmt = (n) => (Number(n) || 0).toLocaleString();
  return (
    <div className="text-center py-6 space-y-5" data-testid="wiz-step-done">
      <div className={`mx-auto w-16 h-16 rounded-full flex items-center justify-center ${result.queued ? "bg-amber-100 text-amber-600" : "bg-emerald-100 text-emerald-600"}`}>
        {result.queued ? <Clock size={34} /> : <CheckCircle2 size={34} />}
      </div>
      <div>
        <h3 className="font-heading text-xl font-semibold text-slate-900" data-testid="wiz-done-title">{result.queued ? "Sent for admin approval" : "Saved!"}</h3>
        <p className="text-sm text-slate-600 mt-1" data-testid="wiz-done-msg">
          {result.queued ? result.queued : (
            <>
              <b className="text-emerald-700">{fmt(result.good)} pcs</b> of <b>{model}</b> from <b>{process.name}</b>
              {result.next ? <> are now ready for <b>{result.next.name}</b>.</> : " recorded at the final stage."}
              {result.coilNo ? <span className="block text-xs text-slate-400 mt-1">Coil {result.coilNo} reduced.</span> : null}
            </>
          )}
        </p>
      </div>
      <div className="flex flex-col sm:flex-row gap-2 justify-center">
        <button data-testid="wiz-again" onClick={onAgain} className="bg-blue-600 hover:bg-blue-700 text-white rounded-xl px-5 py-3 text-sm font-semibold flex items-center justify-center gap-2"><Plus size={16} /> Another entry · {process.name}</button>
        <button data-testid="wiz-other" onClick={onOther} className="bg-white border border-slate-300 hover:border-blue-400 text-slate-700 rounded-xl px-5 py-3 text-sm font-semibold flex items-center justify-center gap-2"><ListChecks size={16} /> Different machine</button>
        <button data-testid="wiz-finish" onClick={onClose} className="bg-slate-900 hover:bg-slate-800 text-white rounded-xl px-5 py-3 text-sm font-semibold flex items-center justify-center gap-2"><X size={16} /> Done</button>
      </div>
    </div>
  );
}
